import { xyz_n_1of4 } from './SL00000Sprint00TTR'

import { list49200Sprint04 } from '../ActivityLists/AL49200Sprint04'
import { list49200Sprint05 } from '../ActivityLists/AL49200Sprint05'

// Software Systems Capstone (SSC) sprint 5 global values.
const sprint = 5
const activityList = () => { return list49200Sprint05(sprint) }
const activityListPrevious = () => { return list49200Sprint04(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const ssc_5_1of4 = () => { return xyz_n_1of4(null, null, sprintAndActivityLists, null) }

export const ssc_5_slidedeckTTR = [ ssc_5_1of4, null, null, null ]